import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { setDarkMode, useMaterialUIController } from "context";
import PageLayout from "examples/LayoutContainers/PageLayout";
import PropTypes from "prop-types";

function IllustrationLayout({ isModify = false, header, title, description, illustration, children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;

  const handleSetDarkMode = () => {
    setDarkMode(dispatch, !darkMode);
    sessionStorage.setItem("tema", !darkMode);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageLayout background="white">
      <MDBox sx={{ position: "fixed", top: 16, right: 16, zIndex: 99 }}>
        <IconButton
          size="small"
          onClick={handleSetDarkMode}
          sx={{
            color: darkMode ? "#fff !important" : "#7b809a",
            "&:hover": {
              backgroundColor: darkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
            }
          }}
        >
          {darkMode ? <LightModeIcon sx={{ fontSize: "1.1rem" }} /> : <DarkModeIcon sx={{ fontSize: "1.1rem" }} />}
        </IconButton>
      </MDBox>
      <Grid
        container
        sx={{
          minHeight: "100vh",
          backgroundColor: ({ palette: { background, white } }) =>
            darkMode ? background.default : white.main,
        }}
      >
        {!isModify && (
          <Grid item xs={12} lg={6} display="flex" justifyContent="center" alignItems="flex-start">
            {isMobile ? (
              <MDBox
                component="img"
                src={illustration}
                alt="Logo"
                width="290px"
                maxWidth="80%"
                mx="auto"
                my={3}
              />
            ) : (
              <MDBox
                display="flex"
                width="calc(100% - 4rem)"
                height="calc(100vh - 3rem)"
                ml={2}
                mt={2}
                sx={{
                  backgroundImage: `url(${illustration})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sm={10}
          md={6}
          lg={5}
          xl={4}
          mx="auto"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          px={3}
          py={isMobile ? 4 : 0}
        >
          {!isModify ? (
            <MDBox width="100%">
              <MDBox py={isMobile ? 1 : 3} px={3} textAlign="center">
                {!header ? (
                  <>
                    <MDBox mb={1}>
                      <MDTypography variant="h4" fontWeight="bold">
                        {title}
                      </MDTypography>
                    </MDBox>
                    <MDTypography variant="body2" color="text">
                      {description}
                    </MDTypography>
                  </>
                ) : (
                  header
                )}
              </MDBox>
              <MDBox mt={4} width="100%">
                {children}
              </MDBox>
            </MDBox>
          ) : (
            <MDBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              width="100%"
              py={4}
              px={3}
            >
              {illustration && (
                <MDBox
                  component="img"
                  src={illustration}
                  alt="Illustration"
                  width="200px"
                  maxWidth="80%"
                  mb={3}
                />
              )}
              {!header ? (
                <>
                  <MDTypography variant="h4" fontWeight="bold" mb={1}>
                    {title}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    {description}
                  </MDTypography>
                </>
              ) : (
                header
              )}
              <MDBox mt={4} width="100%">
                {children}
              </MDBox>
            </MDBox>
          )}
        </Grid>
      </Grid>
    </PageLayout>
  );
}

IllustrationLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string,
};

export default IllustrationLayout;
